import * as React from "react";
import { Cascader } from "antd";
import { connect } from "react-redux";
import { getFromSource } from "utils/interface";
import { CQ } from "utils/commonQuest";

interface IOrderSourceCascaderProps {
  width?: number;
  setValue?: any;
  share?: any;
  // 默认值
  defaultValue?: any;
  value?: any;
  style?: React.CSSProperties;
  // 自定义字段，映射viewModel的字段
  "data-field"?: any;
  "first-field"?: any;
  "second-field"?: any;
  isLoadCity?: any;
  modelName?: any;
  onChange?: any;
  // redux中管理的表单数据
  reduxFormData?: any;
  // 用于找到父节点的选择器
  containerBody?: any;
}

// 异步请求接口，阻塞进程获取数据后执行回调函数
async function getData(callback, id = 0, type = "first") {
  id = type === "first" ? 0 : id;
  const data = await CQ(
    getFromSource({
      id: id
    })
  );

  const _data = data.map(item => {
    let _data = {
      label: item.name,
      value: item.id
    };
    if (type === "first") {
      _data["isLeaf"] = false;
    }
    return _data;
  });

  callback && callback(_data);
}

// 订单来源级联
class OrderSourceCascader extends React.Component<
  IOrderSourceCascaderProps,
  any
> {
  state = {
    value: [],
    first: "",
    second: "",
    options: []
  };

  constructor(props: IOrderSourceCascaderProps) {
    super(props);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const reduxFormData = nextProps.reduxFormData;
    // 清空数据
    if (!reduxFormData[nextProps.modelName][nextProps["second-field"]]) {
      return {
        value: []
      };
    } else return prevState;
  }

  componentDidMount() {
    getData(data => {
      this.setState({
        options: data
      });
    });
  }

  // 选完数据后触发
  onChange = value => {
    let data = {};

    // data[this.props["data-field"]] = value[0];
    if (value.length == 2) {
      data[this.props["first-field"]] = value[0];
      data[this.props["second-field"]] = value[1];
    } else {
      data[this.props["first-field"]] = value[0];
      data[this.props["second-field"]] = value[0];
    }

    this.props.setValue({
      formInfo: data,
      model: this.props.modelName
    });
  };

  // 加载二级数据
  loadData = selectedOptions => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    if (targetOption.loading) return;
    targetOption.loading = true;

    getData(
      _data => {
        const children = _data;

        targetOption.loading = false;
        targetOption.children = children;
        this.setState({
          options: [...this.state.options]
        });
      },
      targetOption.value,
      "second"
    );
  };

  filter = (inputValue, path) => {
    return path.some(
      option =>
        option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );
  };

  getContainer = () => {
    const containerBody = this.props.containerBody;
    if (containerBody) {
      return document.querySelector(containerBody) || document.body;
    } else {
      return document.body;
    }
  };

  render() {
    let value: any = [];
    const first = this.props.reduxFormData[this.props.modelName][
        this.props["first-field"]
      ],
      second = this.props.reduxFormData[this.props.modelName][
        this.props["second-field"]
      ];

    if (first || second) {
      value = [first, second];
    } else {
      value = [];
    }

    return (
      <Cascader
        options={this.state.options}
        value={value}
        loadData={this.loadData}
        onChange={this.onChange}
        style={{ width: this.props.width || 220 }}
        changeOnSelect={true}
        showSearch={{ filter: this.filter }}
        placeholder="订单来源"
        getPopupContainer={this.getContainer}
      />
    );
  }
}

const mapState = state => ({
  reduxFormData: state.antDemo
});

const mapDispatch = dispatch => {
  return {
    setValue: dispatch.antDemo.setValue
  };
};

export default connect(
  mapState,
  mapDispatch
)(OrderSourceCascader);
